import { render, staticRenderFns } from "./DeviceCategoryEdit.vue?vue&type=template&id=f38825e0&scoped=true"
import script from "./DeviceCategoryEdit.vue?vue&type=script&lang=js"
export * from "./DeviceCategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./DeviceCategoryEdit.vue?vue&type=style&index=0&id=f38825e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38825e0",
  null
  
)

export default component.exports